import { useState } from "react";
import { Reactable } from "../../components/ui/reactable";
import { DAYWISE_ATTENDANCE_REPORTS } from "../../constants/api";
import { EmployeeDetails } from "../../components/ui/cards";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { ChevronLeftIcon } from "lucide-react";

const DayWiseAttendance = () => {

    const [dayWiseAttendanceData, setDayWiseAttendanceData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    let navigate = useNavigate()
    const dayWiseAttendanceColumns = [
        {
            accessor: "employee_name",
            Header: "Employee",
            sortable: true,
            fixed: true,
            filterable: true,
            maxWidth: "300px",
            Cell: ({ value, row }) => {
                const record = row;

                let empDetails = {
                    ...record?.employee,
                    designation_id: record?.employee?.designation
                        ? {
                            id: record?.employee.designation.id,
                            designation_name: record?.employee.designation.name,
                        }
                        : { id: 0, designation_name: "" },
                    first_name: record?.employee?.employee_name || "-",
                    id: record?.employee?.employee_id || "-",
                };

                return <EmployeeDetails details={empDetails} size="xs" />;
            },
        },
        {
            accessor: "status",
            Header: "Status",
            filterable: true,
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "check_in",
            Header: "Check In",
            Cell: ({ value }) =>
                value && dayjs(value).isValid()
                    ? dayjs(value).format("HH:mm:ss")
                    : "-",
        },
        {
            accessor: "check_out",
            Header: "Check Out",
            Cell: ({ value }) =>
                value && dayjs(value).isValid()
                    ? dayjs(value).format("HH:mm:ss")
                    : "-",
        },
        {
            accessor: "late_hours",
            Header: "Late Hours",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "break_hrs",
            Header: "Break Hours",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "total_working_hours",
            Header: "Total Hours",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "location",
            Header: "Location",
            Cell: ({ value }) => value ?? "-",
        },
    ];

    return (
        <div className="p-4 dark:bg-gray-900 rounded-lg dark:shadow-md font-sans">
            <div className="flex justify-between items-center mb-4">
                <span className=" flex gap-2 items-center">
                    <ChevronLeftIcon onClick={() => { navigate('/reports') }} className=" cursor-pointer" />
                    <h1 className="text-2xl font-semibold text-gray-900 dark:text-gray-100">
                        Day Wise Attendance Report ({totalRecords})
                    </h1>
                </span>
            </div>

            <Reactable
                columns={dayWiseAttendanceColumns}
                data={dayWiseAttendanceData}
                setData={setDayWiseAttendanceData}
                setTotalCount={setTotalRecords}
                url={DAYWISE_ATTENDANCE_REPORTS}
                serverSide={true}
                tableHeight="calc(100vh - 310px)"
                rowSize="sm"
                isCSVRequired={true}
                isPDFRequired={true}
                isDateRequired={true}
            />
        </div >
    );
}

export default DayWiseAttendance;